<template>
    <div class="homepage__problems-solved">
        <div class="wrap">
            <div class="nr">3,000,000</div>
            <div class="text">math problems solved every day</div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.homepage__problems-solved {
    background-color: #b686f6;
    background-image: url('/images/lp/stars-left-3.svg'),
        url('/images/lp/stars-right-3.svg');
    background-repeat: no-repeat, no-repeat;
    background-position:
        2% 50%,
        97% 50%;
    width: 100%;
    padding: 0 6rem;
    box-sizing: border-box;
    overflow: hidden;

    @include mq($w-max-phone, max) {
        background-image: none;
        padding: 0;
    }

    .wrap {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 172px;
        padding: 1.5rem 0;

        @include mq($w-max-tablet, max) {
            flex-direction: column;
        }

        @include mq($w-max-phone, max) {
            min-height: auto;
            padding: 2rem 1.5rem;
        }

        .nr {
            padding-right: 1.5rem;
            font-weight: 700;
            font-size: 72px;
            text-shadow: 0 4px 4px rgba(0, 0, 0, 0.16);

            @include mq($w-max-desktop, max) {
                padding-right: 1.25rem;
                font-size: 64px;
            }

            @include mq($w-max-tablet, max) {
                padding: 0;
            }

            @include mq($w-max-phone, max) {
                font-size: 46px;
            }
        }

        .text {
            font-weight: 600;
            font-size: 32px;
            text-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);

            @include mq($w-max-tablet, max) {
                margin-top: 1rem;
            }

            @include mq($w-max-phone, max) {
                font-size: 18px;
                text-align: center;
            }
        }
    }
}
</style>
